
import { computed, defineComponent, PropType } from 'vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'

export interface InternalLinksListType {
  [key: string]: any // eslint-disable-line
}
export interface InternalLinksType {
  list: InternalLinksListType
}

export default defineComponent({
  name: 'InternalLinks',

  components: {
    HeadingLv3
  },

  props: {
    list: {
      type: Object as PropType<InternalLinksListType>
    }
  },

  setup(props) {
    const conditionsList = computed(() => {
      return [
        {
          title: '病院種別',
          list: props.list?.hospital_class
        },
        {
          title: '救急指定',
          list: props.list?.designated_hospital
        },
        {
          title: '希望条件',
          list: {
            ...props.list?.bonus,
            ...props.list?.overtime_hours_mavg,
            ...props.list?.house
          }
        },
        {
          title: 'こだわり条件',
          list: props.list?.discerning_conditions
        },
        {
          title: '病床数',
          list: props.list?.bed_num
        },
        {
          title: '医師数',
          list: props.list?.doctor_num
        },
        {
          title: '募集人数',
          list: props.list?.positions_num
        },
        {
          title: '年収',
          list: props.list?.income
        },
        {
          title: '当直回数',
          list: props.list?.shifts_num
        }
      ]
    })

    const areaList = computed(() => {
      const hasArea =
        typeof props.list?.prefectures[
          Object.keys(props.list?.prefectures)[0]
        ] === 'object'

      if (hasArea) {
        return Object.keys(props.list?.prefectures).map((area) => {
          return {
            title: area,
            list: props.list?.prefectures[area]
          }
        })
      }

      return [
        {
          title: '',
          list: props.list?.prefectures
        }
      ]
    })

    return {
      conditionsList,
      areaList
    }
  }
})
